<template>
  <div class="mxzc-wrap">
      <div class="mxzc">
          <div style="width:100%;height:158px"></div>
          <div class="sta-title">
              名下资产信息
          </div>
          <div class="sta-more">
              More
              <div class="sta-more1"></div>
          </div>
          <div class="mxzc-items">
              <div v-for="(item,index) in assetList" :key="index" class="mxzc-item">
                  <div class="mxzc-item1"></div>
                  <div class="mxzc-item2">{{Math.round(item.rowData.shul)}}
                      <span class="mxzc-item2-dw">{{getdanwei(item.rowData.danw)}}</span>
                      <!-- <div class="mxzc-item2-dw">台</div> -->
                  </div>
                  <div class="mxzc-item3">{{"¥"+item.rowData.jine}}</div>
                  <div class="mxzc-item4">{{item.rowData.hangyflName}}</div>
                  <div class="mxzc-item5">{{item.rowData.cunfddName}}</div>
                  <div class="mxzc-item6">查看详情
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-chakanxiangqing"></use>
                        </svg>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  components:{
  },
  data () {
    return {
        assetList:[]
    }
  },
  methods: {
      getdanwei(danw){
          if(danw == '平方米'){
              return "m²"
          }else{
              return '台'
          }
      },
      getmxzc(){
          let paramter = {}
          GMS.$http.post('/own/asset/list',paramter).then(res=>{
            if(res.status == 200){
                let data = res.data.extraData.slice(0,3)
                this.assetList = data;
            }
        }).catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
        })
      }
  },
  mounted(){
      this.getmxzc()
  },
}
</script>

<style lang="less" scoped>
.mxzc-wrap{
    width: 100%;
    height: 685px;
    .mxzc{
        width: 1200px;
        margin: 0 auto;
    }
    .sta-title{
        height: 42px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 30px;
        color: #424242;
        letter-spacing: 0;
        line-height: 42px;
        text-align: center;
        margin-bottom: 24px;
    }
    .sta-more{
        width: 39px;
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #7F7F7F;
        line-height: 22px;
        position: relative;
        margin: 0 auto;
        margin-bottom: 54px;
    }
    .sta-more1{
        position: absolute;
        left: 47px;
        bottom: 4px;
        width: 14px;
        height: 10px;  
        background: url('../../../static/statistics/more@2x.webp'); 
        background-size: 14px 10px;
    }
    .mxzc-item{
        float: left;
        width: 370px;
        height: 315px;
        background: #FFFFFF;
        box-shadow: 0 0 20px 0 rgba(0,0,0,0.10);
        position: relative;
        margin-bottom: 70px;
    }
    .mxzc-item:nth-child(2){
        margin-left: 40px;
        margin-right: 40px;
    }
    
    .mxzc-item1{
        width: 100%;
        height: 31px;
    }
    .mxzc-item2{
        width: 200px;
        height: 70px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 50px;
        color: #003670;
        margin: 0 auto;
        margin-bottom: 8px;
        line-height: 70px;
        text-align: center;
        position: relative;
        .mxzc-item2-dw{
            // width: 16px;
            // height: 22px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 16px;
            color: #7F7F7F;
            // left: 69px;
            // top: 12px;
        }
    }
    .mxzc-item3{
        height: 25px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 18px;
        color: #FF9D00;
        text-align: center;
        line-height: 25px;
        margin-bottom: 26px;
    }
    .mxzc-item4{
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #0F0F0F;
        line-height: 22px;
        text-align: center;
        margin-bottom: 18px;
    }
    .mxzc-item5{
        height: 22px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #787878;
        line-height: 22px;
        text-align: center;
    }
    .mxzc-item6{
        width: 100%;
        left: 0;
        bottom: 0;
        position: absolute;
        height: 61px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #0F0F0F;
        letter-spacing: 0;
        text-align: center;
        line-height: 61px;
        border-top: 1px solid #EDEDED;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/mxzc.vue